module.exports = __webpack_public_path__ + "static/media/Gatwick-Bold.43e1b67c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Gatwick-Bold.otf
// module id = 3181
// module chunks = 68